var _ellipse, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9126,
    cy: 78,
    rx: 56.2232,
    ry: 57.0181,
    stroke: "#1681FF",
    strokeOpacity: 0.25,
    strokeWidth: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5224 20.9834C91.4333 20.8787 105.775 26.7854 116.391 37.404C127.008 48.0227 133.03 62.4836 133.133 77.6053",
    stroke: "url(#paint0_linear_2994_6448)",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2994_6448",
    x1: 125.449,
    y1: 106.776,
    x2: 27.6844,
    y2: 50.4203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#1681FF",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1681FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.67c94ba0c03e9de6c5c873b8ac08da9a.svg";
export { ForwardRef as ReactComponent };